export const CARD_TITLE_SELECTOR = '[data-alpha-card-title]';

const CARD_REGION_SELECTOR = '[data-alpha-card-region]';
const ACTION_SELECTOR = 'button, [role="button"]';
const TYPING_ROLES = ['textbox', 'combobox', 'searchbox', 'spinbutton'];

const isTypingTarget = (element: Element): boolean =>
  element instanceof HTMLInputElement ||
  element instanceof HTMLTextAreaElement ||
  element instanceof HTMLSelectElement ||
  (element instanceof HTMLElement && element.isContentEditable) ||
  TYPING_ROLES.includes(element.getAttribute('role') ?? '');

export const focusMayMove = (within?: Element | null): boolean => {
  const active = document.activeElement;
  if (active === null || active === document.body) {
    return true;
  }
  if (isTypingTarget(active)) {
    return false;
  }
  return (
    active.closest(CARD_REGION_SELECTOR) !== null ||
    (within?.contains(active) ?? false)
  );
};

export const isActionElement = (element: Element): boolean =>
  element.closest(ACTION_SELECTOR) !== null;

export const focusCardTitle = (root: ParentNode | null): void => {
  root?.querySelector<HTMLElement>(CARD_TITLE_SELECTOR)?.focus();
};
